module.exports = __webpack_public_path__ + "static/img/mask.9a3ce99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/download-new/mask.png
// module id = 44lq
// module chunks = 3